const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Returns an error message, or undefined when the e-mail is valid. */
export function validateEmail(value) {
  const trimmed = value.trim();
  if (!trimmed) return 'Please enter your e-mail address.';
  if (!EMAIL_RE.test(trimmed)) return 'Please enter a valid e-mail address, e.g. name@example.com.';
  return undefined;
}

export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 72;

/** Same rules as the backend: 6–72 characters. Returns an error message or undefined. */
export function validateNewPassword(value) {
  if (!value) return 'Please enter a new password.';
  if (value.length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if (value.length > PASSWORD_MAX) return `Use at most ${PASSWORD_MAX} characters.`;
  return undefined;
}

/** Confirmation must be filled in and identical to the new password. */
export function validateConfirmPassword(password, confirm) {
  if (!confirm) return 'Please confirm your new password.';
  if (password !== confirm) return 'Passwords do not match.';
  return undefined;
}
